import React from 'react'
import { Theme, createStyles, makeStyles } from '@material-ui/core';
import { Box, Button, Grid } from '@mui/material';
import DataGrid from "../common/Table/newTable";
import { LateSwapLineup, LateSwapLineupResponse, LateSwapPlayer, LineupInfo } from './store/types';
import { APIState } from '../utils/api/reducer';
import { useLocalStorage } from 'usehooks-ts';
import { MenuOption } from '../common/selectOptions';
import { lateSwapLineupDataGridHeaderConfig } from '../common/Table/lateSwapConfig';
import { DataGridProProps, GridColDef, GridRenderCellParams } from '@mui/x-data-grid-pro';
import { getFirstInitialLastName } from '../utils/stringUtils';
import LockIcon from '@material-ui/icons/Lock';
import { Stack } from '@mui/material';
import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder';
import FavoriteIcon from '@material-ui/icons/Favorite';
import { GridApiPro } from '@mui/x-data-grid-pro/models/gridApiPro';
import { CSVLink } from 'react-csv';
import GetAppIcon from "@material-ui/icons/GetApp";
import { connect } from 'react-redux';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import { SwapHoriz } from '@material-ui/icons';
import { getBoostRoiForLineup, getLineupUniqueHash } from './utils';
import { SlateResponse } from '../common/store/types';
import { getFilename } from '../common/helpers/FilenameHelper';
import { LateSwapOverview } from '../common/LineupPortfolioOverview';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    stepperWrapper: {
      backgroundColor: "#031630",
      borderRadius: "3px 3px 0px 0px",
      color: 'white',
      padding: 12,
      '& .MuiStepLabel-label.MuiStepLabel-alternativeLabel': {
        color: 'rgba(255, 255, 255, 0.60)',
        fontSize: 14,
      },
      '& .MuiStepIcon-root': {
        color: 'rgba(255, 255, 255, 0.38)'
      },
      '& .MuiStepIcon-completed': {
        color: '#009C06',
      },
      '& .MuiStepIcon-active': {
        color: '#0058CC',
      }
    },
    heading: {
      '& .MuiDivider-root': {
        backgroundColor: 'rgba(251, 255, 57, 0.30)',
      }
    },
    generatorSettings: {
      backgroundColor: "#031630",
      padding: 12,
      '& .MuiStepIcon-active': {
        color: '#0058CC',
      }
    },
    active: {
      backgroundColor: "#031630",
    },
    buttonWrapper: {
      paddingRight: "8px",
    },
    exportButton: {
      height: 40,
      borderRadius: 3,
      backgroundColor: '#0042C1',
      textWrap: 'nowrap',
      padding: "10px 16px",
      margin: "4px 0",
      marginLeft: 8,
      "& a": {
        color: "white !important",
        textDecoration: "none",
        display: "flex",
        alignItems: "center",
      },
      "&:hover": {
        color: "white",
        backgroundColor: '#0042C1',
      },
      "& .MuiSvgIcon-root": {
        marginLeft: 4,
        fontSize: "1rem",
      },
    },
    exportButtonCG: {
      height: 40,
      borderRadius: 3,
      textWrap: 'nowrap',
      padding: "10px 16px",
      margin: "4px 0",
      marginLeft: 8,
      "& a": {
        color: "white !important",
        textDecoration: "none",
        display: "flex",
        alignItems: "center",
      },
      "& .MuiSvgIcon-root": {
        marginLeft: 4,
        fontSize: "1rem",
      },
    },
    goToPre: {
      display: "flex",
      padding: "8px 16px",
      justifyContent: "center",
      alignItems: "center",
      gap: "4px",
      color: "white",
      textDecoration: "none",
      backgroundColor: "#0042C1",
      borderRadius: "3px",
      textTransform: "uppercase",
      fontSize: 12,
      fontWeight: 500,
      "& .MuiSvgIcon-root": {
        color: "#7CA9FF !important",
      },
      "&:hover": {
        color: "white",
        backgroundColor: "#0042C1",
        "& .MuiSvgIcon-root": {
          color: "white !important",
        },
      },
    },
    lateSwapOptions: {
      overflowY: 'auto',
    },
    disabled: {
      pointerEvents: "none",
      color: "white !important",
      backgroundColor: "#555555 !important",
      "& .MuiSvgIcon-root": {
        color: "white !important",
      },
    },
    button: {
      borderRadius: 3,
      background: '#0042C1',
      color: 'white',
      padding: '8px 16px',
      marginLeft: 8,
      '&:hover': {
        background: '#0042C1',
      },
      '&:disabled': {
        backgroundColor: '#555555 !important',
        color: '#BEBEBE'
      }
    },
    regenerate: {
      display: "flex",
      justifyContent: "center",
      padding: "8px 16px",
      alignItems: "center",
      gap: "4px",
      backgroundColor: "#008F05",
      paddingRight: "8px",
      color: "white",
      textDecoration: "none",
      borderRadius: "3px",
      textTransform: "uppercase",
      fontSize: 14,
      fontWeight: 500,
      "&:hover": {
        color: "white",
        backgroundColor: "#008F05",
      },
      "&:disabled": {
        color: "white !important",
        backgroundColor: "#555555 !important",
        "& .MuiSvgIcon-root": {
          color: "white !important",
        },
      },
    },
  })
);



interface PlayerGroup {
  id: string;
  players: LateSwapPlayer[];
  roiBoost: number;
}

interface OwnProps {
  readonly selectedContest: MenuOption<any>;
  readonly exportCsvHeader: string;
  readonly filteredLineupNumber: string;
  readonly filteredHashcode: string;
  readonly setFilteredLineupNumber: (newNumber) => void;
  readonly savedLineupsWhenFiltered: LateSwapLineup[];
  readonly setSavedLineupsWhenFiltered: (savedLineups: LateSwapLineup[]) => void;
  readonly setFilteredHashcode: (newNumber) => void;
  readonly boostedPlayersList: { [key: string]: number };
  readonly boostedStackList: { [key: string]: number };
  readonly playerGroups?: PlayerGroup[];
  readonly onApiRefReady?: (apiRef: React.MutableRefObject<GridApiPro>) => void;
}

interface ReduxProps {
  readonly contestLineups: APIState<LateSwapLineupResponse>;
  readonly selectedSlate: SlateResponse;
}

type Props = OwnProps & ReduxProps;

export const getLineupPositionColDefs = (lineupPositions: LineupInfo[], lineupHeaders: string[]) => {
  const lineupPos = lineupPositions.map((pos, index) => {
    return {
      field: lineupHeaders[index] + index,
      headerName: lineupHeaders[index],
      flex: .1,
      headerAlign: 'left',
      resizable: false,
      align: 'left',
      sortable: false,
      minWidth: 80,
      renderCell: (params: GridRenderCellParams<LateSwapLineup>) => {
        const playerInfo = params.row?.lineupInfo[index];
        return (
          <Grid container className={playerInfo.isLocked ? 'playerLocked' : ''} >
            <Grid item xs={playerInfo.isLocked ? 10 : 12}>
              <Box textOverflow="ellipsis" overflow="hidden" whiteSpace="nowrap" title={playerInfo.name}>
                {['D', 'DST'].includes(playerInfo.position.toUpperCase()) ? playerInfo.name : getFirstInitialLastName(playerInfo.name)}
              </Box>
            </Grid>
            {
              playerInfo.isLocked && (
                <Grid item xs={2}>
                  <LockIcon />
                </Grid>
              )
            }
          </Grid>
        )
      },
    } as GridColDef
  }
  );

  return lineupPos;
};


const LateSwapTable = (props: Props) => {
  const classes = useStyles();
  const { contestLineups, selectedContest, selectedSlate, exportCsvHeader, boostedPlayersList, boostedStackList, filteredHashcode, setFilteredHashcode, setFilteredLineupNumber, setSavedLineupsWhenFiltered, savedLineupsWhenFiltered, playerGroups = [], onApiRefReady } = props;
  const [savedLineups, setSavedLineups] = useLocalStorage<LateSwapLineup[]>(
    "lateswap-lineups",
    []
  );



  const getLineups = () => {
    const lineups = contestLineups.data?.lateSwapData;
    const filteredContestLineups = selectedContest.value === 'all'
      ? lineups
      : lineups.filter(x => x?.associatedLateSwapEntries?.map((entry) => entry.contestName).includes(selectedContest.name));
    if (filteredHashcode !== '') {
      const favoritedLineupHashcodes = savedLineupsWhenFiltered.map(x => getLineupUniqueHash(x));
      const hashCodeFilteredLineups = filteredContestLineups.filter(x => {
        const favoritedLineups = x?.lateSwapOptions?.filter(x => favoritedLineupHashcodes.includes(getLineupUniqueHash(x)));
        if (favoritedLineups && favoritedLineups.length > 0) {
          const favoritedLineup = favoritedLineups[0];
          return favoritedLineup.lineupHashCode === filteredHashcode;
        }
        return false;
      });
      return hashCodeFilteredLineups;
    }
    return filteredContestLineups;
  }

  const handleDupeClicked = (hashcode: string, lineupNumber: string) => {
    setFilteredHashcode(hashcode);
    setFilteredLineupNumber(lineupNumber);
    setSavedLineupsWhenFiltered(savedLineups);
  }

  const getDetailPanelContent = React.useCallback<
    NonNullable<DataGridProProps['getDetailPanelContent']>
  >(({ row }) => <DetailPanelContent row={row} boostedPlayersDict={boostedPlayersList} boostedStacksDict={boostedStackList} slate={selectedSlate} playerGroups={playerGroups} />, [savedLineups, boostedPlayersList, boostedStackList, selectedSlate, playerGroups]);

  const DetailPanelContent = ({ row: rowProp, boostedPlayersDict, boostedStacksDict, slate, playerGroups: groups }: { row: LateSwapLineup, boostedPlayersDict: {}, boostedStacksDict: {}, slate: SlateResponse, playerGroups: PlayerGroup[] }) => {
    const [otherOptionChosen, setOtherOptionChosen] = React.useState(false);
    React.useEffect(() => {
      const lateSwapLineupHashCodes = rowProp?.lateSwapOptions?.map(x => x.lineupHashCode);
      setOtherOptionChosen(savedLineups.some((x => lateSwapLineupHashCodes?.includes(x.lineupHashCode))));
    }, [savedLineups]);

    // React.useEffect(() => {
    //   rowProp.lateSwapOptions?.forEach((lineup) => lineup.roiBoost = getBoostRoiForLineup(lineup));
    //   rowProp.lateSwapOptions?.forEach((lineup) => lineup.finalRoi = getFinalRoi(lineup));

    //   let newOrder = rowProp.lateSwapOptions?.sort(function(a, b) {
    //     console.log(b.finalRoi, a.finalRoi)
    //     console.log((b.finalRoi || 0) - (a.finalRoi || 0));
    //     return (b.finalRoi || 0) - (a.finalRoi || 0);
    //   }) ?? [];
    //   console.log('NEW OPTIONS', newOrder)
    //   setLateSwapOptions(newOrder);
    // }, [boostedPlayersDict]);

    // Calculate group boost for a lineup option
    const getGroupBoost = (lineup: LateSwapLineup): number => {
      if (!lineup.exportableLineup || groups.length === 0) return 0;

      const lineupPlayerIds = lineup.exportableLineup.split(',').map(p => p.trim());
      const cptPlayerId = lineupPlayerIds[0];
      const flexPlayerIds = lineupPlayerIds.slice(1);
      let totalGroupBoost = 0;

      groups.forEach(group => {
        if (group.players.length > 0 && group.roiBoost !== 0) {
          const allPlayersInLineup = group.players.every(player => {
            const playerPos = player.position?.toUpperCase();
            if (playerPos === 'CPT') {
              return player.nameAndId === cptPlayerId;
            } else if (playerPos === 'FLEX') {
              return flexPlayerIds.includes(player.nameAndId);
            }
            return lineupPlayerIds.includes(player.nameAndId);
          });
          if (allPlayersInLineup) {
            totalGroupBoost += group.roiBoost;
          }
        }
      });

      return totalGroupBoost / 100; // Convert to decimal like other boosts
    };

    const getLineups = () => {
      rowProp?.lateSwapOptions?.forEach((lineup) => {
        const playerStackBoost = getBoostRoiForLineup(lineup, slate, boostedPlayersDict, boostedStacksDict);
        const groupBoost = getGroupBoost(lineup);
        lineup.roiBoost = playerStackBoost + groupBoost;
      });
      rowProp?.lateSwapOptions?.forEach((lineup) => lineup.finalRoi = getFinalRoi(lineup));

      let newOrder = rowProp?.lateSwapOptions?.sort(function (a, b) {
        return (b.finalRoi || 0) - (a.finalRoi || 0);
      }) ?? [];
      return newOrder;
    }

    const getFinalRoi = (lineup: LateSwapLineup) => {
      const finalRoi = lineup.simLineupRoi + (lineup.roiBoost ?? 0);
      return finalRoi;
    }

    const getBgColors = (favorited: boolean, original: boolean) => {
      if (favorited) return '#002D69';
      if (original) return '#2C3845';
      return '#152233'
    };

    const isFavorited = (lineup: LateSwapLineup) => {
      return savedLineups.some((x => getLineupUniqueHash(x) === getLineupUniqueHash(lineup)))
    }

    const getTextColor = (boostValue: number) => {
      if (boostValue > 0) {
        return '#00BD08';
      }
      if (boostValue < 0) {
        return '#FF2525';
      }
      return 'white';
    }
    const favoritedLineupHashcodes = savedLineups.map(x => x.lineupHashCode);
    const swapStacks = (stacks: any[]) => {
      const teams = stacks?.map(x => x.team);
      if (selectedSlate.sport?.toUpperCase() === 'NFL' && teams && teams.length > 0) {
        return teams.join('/')
      }
      return teams.join() || '-';
    }
    const swapStackType = (stacks: any[]) => {
      if (selectedSlate.sport?.toUpperCase() === 'NFL') {
          const counts = stacks?.map(x => ({ count: x.count, rbCount: x.runbackCount }));
          if (counts && counts.length > 0) {
            return counts.map(x => x.rbCount > 0 ? `QB + ${x.count} | ${x.rbCount} OPP` : `QB + ${x.count}`).join("/")
          }
        }
        const counts2 = stacks?.map(x => x.count);
        return counts2?.join('-') || '-';
    }

    return (
      <Stack direction="column" justifyContent="space-between" alignItems="center" className={`${classes.lateSwapOptions} MuiDataGrid-row`} style={{ width: '100%' }} key={rowProp.id}>
        {
          getLineups().map((swap, index) => (
            <Stack direction="row" style={{ width: '100%', backgroundColor: getBgColors(isFavorited(swap), swap.originalLineup), borderBottom: '1px solid rgba(238, 238, 238, 0.30)' }} key={index + swap.id + swap.contestId}>
              <Box width="50px" minWidth="50px" minHeight="50px" className="MuiDataGrid-cell MuiDataGrid-cell--textLeft MuiDataGrid-cell--withRightBorder MuiDataGrid-withBorderColor">
                {(favoritedLineupHashcodes.filter(x => x === swap.lineupHashCode).length > 0) && (
                  <Box style={{ height: 24, width: 24 }} display="flex" alignItems='center' justifyContent='center'>
                    <FavoriteIcon
                      style={{
                        color: '#BB7575',
                        width: 18,
                        height: 18
                      }} />
                  </Box>
                )}
              </Box>
              <Stack spacing={0.5} direction='row' width="125px" minHeight="50px" minWidth="125px" maxHeight="50px" maxWidth="125px" className="MuiDataGrid-cell MuiDataGrid-cell--textLeft MuiDataGrid-cell--withRightBorder MuiDataGrid-withBorderColor">
                {
                  swap.originalLineup ? (
                    <>
                      Original Lineup
                    </>
                  ) : (
                    <>
                      Lineup {String.fromCharCode(index + 1 + 64).toLowerCase()}
                    </>
                  )
                }
              </Stack>
              <Box width="120px" minHeight="50px" minWidth="120px" maxHeight="50px" maxWidth="120px" className="MuiDataGrid-cell MuiDataGrid-cell--textLeft MuiDataGrid-cell--withRightBorder MuiDataGrid-withBorderColor">
                <Stack direction='row' >
                  {`${(((swap.roiBoost ?? 0) + swap.simLineupRoi) * 100).toFixed(1)}%`}
                  {(swap.roiBoost && swap.roiBoost !== 0) ? (
                    <Box sx={{ color: getTextColor(swap.roiBoost ?? 0), alignItems: 'center', display: 'flex' }}>
                      {(swap.roiBoost > 0) && (
                        <ArrowUpwardIcon style={{ color: 'inherit' }} fontSize='small' />
                      )}
                      {(swap.roiBoost < 0) && (
                        <ArrowDownwardIcon style={{ color: 'inherit' }} fontSize='small' />
                      )}
                      {(swap.roiBoost * 100).toFixed(0)}%
                    </Box>
                  ) : ''}
                </Stack>

              </Box>
              <Box width="100px" minHeight="50px" minWidth="100px" maxHeight="50px" maxWidth="100px" className="MuiDataGrid-cell MuiDataGrid-cell--textLeft MuiDataGrid-cell--withRightBorder MuiDataGrid-withBorderColor">
                {swap.simAverageFantasyPoints}
              </Box>
              <Box width="100px" minHeight="50px" minWidth="100px" maxHeight="50px" maxWidth="100px" className="MuiDataGrid-cell MuiDataGrid-cell--textLeft MuiDataGrid-cell--withRightBorder MuiDataGrid-withBorderColor">
                {swap.ownershipSumPct}
              </Box>
              <Box width="100px" minHeight="50px" minWidth="100px" maxHeight="50px" maxWidth="100px" className="MuiDataGrid-cell MuiDataGrid-cell--textLeft MuiDataGrid-cell--withRightBorder MuiDataGrid-withBorderColor">
                ${swap.salary}
              </Box>
              <Box width="100px" minHeight="50px" minWidth="100px" maxHeight="50px" maxWidth="100px" className="MuiDataGrid-cell MuiDataGrid-cell--textLeft MuiDataGrid-cell--withRightBorder MuiDataGrid-withBorderColor">
                {swapStacks(swap.stacks)}
              </Box>
              <Box width="100px" minHeight="50px" minWidth="100px" maxHeight="50px" maxWidth="100px" className="MuiDataGrid-cell MuiDataGrid-cell--textLeft MuiDataGrid-cell--withRightBorder MuiDataGrid-withBorderColor">
                {swapStackType(swap.stacks)}
              </Box>
              <Stack direction='row' flexGrow={1} flexShrink={1} flex={1} flexDirection={'row'}>
                {
                  swap.lineupInfo?.map(pos => (
                    <Box minHeight="50px" minWidth="80px" width={`${100 / swap.lineupInfo?.length || 0}%`} maxHeight="50px" className="MuiDataGrid-cell MuiDataGrid-cell--textLeft MuiDataGrid-cell--withRightBorder MuiDataGrid-withBorderColor" key={index + pos.nameAndId}>
                      <Grid container className={pos.isLocked ? 'playerLocked' : ''} >
                        <Grid item xs={pos.isLocked ? 10 : 12}>
                          <Box textOverflow="ellipsis" overflow="hidden" whiteSpace="nowrap" title={pos.name}>
                            {['D', 'DST'].includes(pos.position.toUpperCase()) ? pos.name : getFirstInitialLastName(pos.name)}
                          </Box>

                        </Grid>
                        {
                          pos.isLocked && (
                            <Grid item xs={2}>
                              <LockIcon />
                            </Grid>
                          )
                        }
                      </Grid>
                    </Box>
                  ))
                }
              </Stack>
              <Box width="100px" minHeight="50px" minWidth="100px" maxHeight="50px" maxWidth="100px" className="MuiDataGrid-cell MuiDataGrid-cell--textLeft MuiDataGrid-cell--withRightBorder MuiDataGrid-withBorderColor" >
                <FavoriteIcons lineup={swap} parentLineup={rowProp} otherOptionChosen={otherOptionChosen} otherOptions={rowProp?.lateSwapOptions || []} />
              </Box>
            </Stack >
          ))
        }
      </Stack >
    );
  };
  const FavoriteIcons = (props: { lineup: LateSwapLineup; otherOptionChosen: boolean; otherOptions: LateSwapLineup[], parentLineup: LateSwapLineup }) => {
    const { lineup, otherOptions, parentLineup } = props;
    const [isFavorited, setIsFavorited] = React.useState(false);

    React.useEffect(() => {
      setIsFavorited(savedLineups.some((x => getLineupUniqueHash(x) === getLineupUniqueHash(lineup))));
    }, [savedLineups]);
    return (
      <>
        <Grid container justifyContent="space-between" style={{ padding: 2, fontSize: '16px', }} key={lineup.lineupHashCode}>
          <Grid container item xs={12} alignItems='center' justifyContent='center' onClick={() => setFavoriteLineup(lineup, parentLineup, otherOptions)}>
            {
              isFavorited ? (
                <FavoriteIcon
                  style={{
                    cursor: 'pointer',
                    color: '#f44336',
                    maxWidth: 50,
                  }} />
              ) : (
                <FavoriteBorderIcon
                  style={{
                    cursor: 'pointer',
                  }} />
              )
            }
          </Grid>
        </Grid>
      </>
    )
  }
  const setFavoriteLineup = (lineup: LateSwapLineup, parentLineup: LateSwapLineup, otherOptions?: LateSwapLineup[]) => {
    lineup.associatedLateSwapEntries = parentLineup?.associatedLateSwapEntries;
    lineup.parentRoi = parentLineup.simLineupRoi;
    lineup.lineupNumber = parentLineup.lineupNumber;
    let alreadySavedLineups = savedLineups;
    if (alreadySavedLineups.some((x) => getLineupUniqueHash(x) === getLineupUniqueHash(lineup))) {
      alreadySavedLineups = alreadySavedLineups.filter(
        (x) => getLineupUniqueHash(x) !== getLineupUniqueHash(lineup)
      );
      setSavedLineups(alreadySavedLineups);
    } else {
      const otherOptionsHashCodes = otherOptions?.map(x => getLineupUniqueHash(x));
      alreadySavedLineups = alreadySavedLineups.filter(x => {
        const has = !otherOptionsHashCodes?.includes(getLineupUniqueHash(x));

        return has;
      });

      alreadySavedLineups.push(lineup);
      setSavedLineups(alreadySavedLineups);
    }
  };

  const footer = (apiRef: React.MutableRefObject<GridApiPro>) => {
    const filterExportData = (apiRef: React.MutableRefObject<GridApiPro>) => {
      if (savedLineups?.length > 0) {
        let csvData = "";
        let sortedLineups = apiRef.current.getSortedRows() as LateSwapLineup[];
        const header = exportCsvHeader;
        let sortedSavedLinups: LateSwapLineup[] = [];
        sortedLineups.forEach(sortedL => {
          let matchedLineup = savedLineups.find(unsortedL => {
            return unsortedL.lateSwapId + unsortedL.contestId === sortedL.lateSwapId + sortedL.contestId
          })
          if (matchedLineup) {
            sortedSavedLinups.push(matchedLineup);
          }
        });
        csvData = header + "\n";
        sortedSavedLinups.forEach((x) => {
          if (x.exportableLineup) {
            x?.associatedLateSwapEntries?.filter((entry) => entry.contestName === selectedContest.name || selectedContest.name?.toLowerCase() === 'all').forEach((associatedContestEntry) => {
              if (selectedSlate?.site?.toLowerCase() === 'fd') {
                csvData = csvData.concat(`${associatedContestEntry.entryId},${associatedContestEntry.contestId},${associatedContestEntry.contestName.replace(',', '')},${associatedContestEntry.entryFee.replace(',', '')},` + x.exportableLineup + "\n");
              } else if (selectedSlate?.site?.toLowerCase() === 'ob') {
                csvData = csvData.concat(`${associatedContestEntry.entryId},${associatedContestEntry.contestId},${associatedContestEntry.contestName.replace(',', '')},${associatedContestEntry.entryFee.replace(',', '')},` + x.exportableLineup + "\n");
              } else if (selectedSlate?.site?.toLowerCase() === 'yh') {
                csvData = csvData.concat(`${associatedContestEntry.contestId},${associatedContestEntry.entryId},` + x.exportableLineup + "\n");
              }
              else {
                csvData = csvData.concat(`${associatedContestEntry.entryId},${associatedContestEntry.contestName.replace(',', '')},${associatedContestEntry.contestId},${associatedContestEntry.entryFee.replace(',', '')},` + x.exportableLineup + "\n");
              }
            })
          }
        });
        return csvData;
      }
      return "";
    }
    return (
      <Stack spacing={1} px='12px' py='10px' direction="row" alignItems='center' justifyContent='space-between' width='100%' pt={1}>
        <Stack>
          <LateSwapOverview lateSwapLineups={getLineups()} />
        </Stack>
        <Stack direction="row" alignItems='center' >
          {savedLineups.length > 0 && (
            <Stack spacing={4} direction="row" alignItems='center' display='flex'>
              <Stack spacing={0.5} direction="row" alignItems='center' display='flex'>
                <Box style={{ height: 18, width: 18, marginRight: 4, }} display="flex">
                  <FavoriteIcon
                    style={{
                      width: 18,
                      height: 18,
                      color: '#BB7575'
                    }} />
                </Box>
                {`${savedLineups.length} Lineups Saved`}
              </Stack>
              <Stack spacing={0.5} direction="row" alignItems='center' display='flex'>
                <Box style={{ backgroundColor: '#004803', opacity: 0.7, height: 18, width: 18, marginRight: 4, }} borderRadius="100px" display="flex">
                  <SwapHoriz style={{ height: 18, width: 18 }} />
                </Box>
                {`${savedLineups.filter(x => !x.originalLineup).length}/${savedLineups.length} Lineups Swapped`}
              </Stack>
              <Stack spacing={0.5} direction="row" alignItems='center' display='flex'>
                <Box style={{ backgroundColor: 'rgba(251, 255, 57, 0.5)', height: 18, width: 18, marginRight: 4, }} borderRadius="100px" display="flex">
                  <Box style={{ color: 'white', justifyContent: 'center', alignItems: 'center', display: 'flex', fontFamily: 'sans-serif', fontWeight: 600, width: '100%' }}>
                    D
                  </Box>
                </Box>
                {`${savedLineups.filter(x => savedLineups.filter(y => y.lineupHashCode === x.lineupHashCode).length > 1).length}/${savedLineups.length} Lineups Duped`}
              </Stack>
            </Stack>
          )}
          <Box className={classes.buttonWrapper}>
            <Button
              className={classes.exportButton}
              disabled={savedLineups?.length === 0}
            >
              <CSVLink
                data={filterExportData(apiRef)}
                filename={getFilename(selectedSlate, `_Late_Swap_Lineups`)}
                target="_blank"
              >
                Export Favorites {savedLineups.length > 0 ? getFilteredRowCount() : ''} <GetAppIcon fontSize="small" />
              </CSVLink>
            </Button>
          </Box>
        </Stack>
      </Stack>
    );
  };

  const getFilteredRowCount = () => {
    let rowCount = savedLineups.filter(
      x => x?.associatedLateSwapEntries !== undefined && x?.associatedLateSwapEntries?.filter(
        (entry) => entry.contestName === selectedContest.name || selectedContest.name?.toLowerCase() === 'all')?.length > 0).length;
    return `(${rowCount})`;
  }

  return (
    <Box maxHeight='calc(100vh - 350px)' height='calc(100vh - 350px)'>
      <DataGrid
        includeStacks={false}
        lineups={getLineups()}
        headers={lateSwapLineupDataGridHeaderConfig(
          savedLineups,
          getLineupPositionColDefs(contestLineups?.data?.lateSwapData[0].lineupInfo ?? [], contestLineups?.data?.lineupPositions),
          boostedPlayersList,
          handleDupeClicked,
          selectedSlate.sport,
          selectedSlate.site,
          boostedStackList,
          playerGroups
        )}
        isLoading={false}
        selectedView="players"
        setPlayerList={() => console.log("")}
        setStackList={() => console.log("")}
        simType={"lateSwap"}
        setStackView={(view: string) => console.log("")}
        emptyText="Fill out settings to start generating."
        fontSize={14}
        footer={(apiRef) => footer(apiRef)}
        getDetailPanelContent={getDetailPanelContent}
        backgroundColor="rgba(219, 77, 0, 0.20)"
        onApiRefReady={onApiRefReady}
      />
    </Box>

  )
}

const mapStateToProps = (state: any) => {
  const {
    contestLineups,
  } = state.lateSwap;

  const {
    selectedSlate,
  } = state.common;

  return {
    contestLineups,
    selectedSlate,
  };
};

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(LateSwapTable);


